import { locationBesonderheit, PlanungsinformationFromThemaRouter } from '../dtos.js';

export function isPcCenterThema(planungsinformation: PlanungsinformationFromThemaRouter | null): boolean {
  return planungsinformation?.locationBesonderheiten.includes(locationBesonderheit.PC_CENTER) ?? false;
}
